import { get } from "../http/backend";

/**
 * 根据订单号精准查询运单信息
 */
 export function searchEwaybill(ewaybillNo: string) {
  return get("/ewaybill", {
    ewaybillNo,
  });
}
 